module.exports = __webpack_public_path__ + "img/logo-nctsg.fc9a5304.gif";